import { render, staticRenderFns } from "./input-email-wizard.vue?vue&type=template&id=48949508&scoped=true&"
import script from "./input-email-wizard.vue?vue&type=script&lang=js&"
export * from "./input-email-wizard.vue?vue&type=script&lang=js&"
import style0 from "./input-email-wizard.vue?vue&type=style&index=0&id=48949508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48949508",
  null
  
)

export default component.exports